<template>
  <div class="py-2">
    <label for="{{forLabel}}" class="block text-sm font-medium text-gray-700">{{label}}</label>
    <div v-if="description" class="text-gray-500 text-xs">
      {{description}}
    </div>
    <div class="mt-1">
        <draggable v-model="options" tag="transition-group" item-key="id">
            <template #item="{element}">
                <div class="flex items-center pb-2">
                    <div class="pr-2 cursor-pointer">
                        <ArrowsUpDownIcon class="h-6 w-6 p-1 bg-gray-200 text-gray-500 rounded-md"/>
                    </div>

                    <input :type="type" placeholder="Item name" :value="element.name" @input="updateValue" class="defaultInput" @blur="updateArray(element.id, $event.target.value)" />
                    <div class="pl-2 cursor-pointer" @click="deleteItemArrayById(element.id)">
                        <XMarkIcon class="h-6 w-6 p-1 bg-gray-200 rounded-full"/>
                    </div>
                </div>
            </template>
        </draggable>

        <div class="pl-8 pt-2">
        <button @click="addItemInArray()" type="submit" class="secondaryButton flex gap-2">
            <DocumentDuplicateIcon class="h-5 w-5 text-gray-400"/>
            {{$t('buttons.add_item')}}
        </button>
        </div>
        
        <p v-if="error" class="mt-2 text-sm text-rose-600">{{error}}</p>

    </div>
  </div>
</template>

<script>

import { XMarkIcon, ArrowsUpDownIcon, DocumentDuplicateIcon } from '@heroicons/vue/24/outline'

import draggable from 'vuedraggable'


export default {
    name: 'ArrayList',
    props: {
        type: {
            type: String,
            default: 'text',
        },
        label: String,
        description: String,
        value: [String, Object, Boolean, Number],
        placeholder: String,
        error: String,
    },
    data() {
        return {
            drag: false,
            options: [
                {id: 1, color: "bg-lime-500", name: 'Backlog', sprints: []},
                {id: 2, color: "bg-blue-500", name: 'In progress', sprints: []},
                {id: 3, color: "bg-rose-500", name: 'Review', sprints: []},
                {id: 4, color: "bg-yellow-600", name: 'Done', sprints: []},
            ],
        }
    },
    components: {
        XMarkIcon,
        ArrowsUpDownIcon,
        DocumentDuplicateIcon,
        draggable,
        
    },
    methods: {
        updateArray(id, value) {
            this.options.forEach(element => {
                if(element.id == id) {
                    element.name = value;
                }
            });
            this.$emit('update:modelValue', this.options);
        },
        deleteItemArrayById(id) {
            this.options = this.options.filter(item => item.id !== id);
        },
        addItemInArray() {
            this.options.push({id: this.options.length + 1,color: '' , name: '', sprints: []});
        },
    },
    watch: {        
        options: function(newValue) {
            this.$emit('update:modelValue', newValue);
        },
    },
    created() {
      this.$emit('update:modelValue', this.arrayList);
    },
}
</script>